import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { getSafeList } from '../../request/index/safeServer'
import { getToken } from '../../request/common'

export default {
    namespaced: true,
    state: {
        // 上市企业列表
        listToken: '',
        listKeyWord: '',
        pageNum: 1,
        pageTotal: 1,
        listData: {},
        noDataIsShow: false,
        listIsShow: false,
        detailIsShow: false,
        listDetail: {}
    },
    mutations: {
        setList(state, payLoad) {
            state.listData = payLoad
        },
        setListKeyWord(state, kw) {
            state.listKeyWord = kw
        },
        setListPageTotal(state, page) {
            state.pageTotal = parseInt(page)
        },
        setListPageNum(state, page) {
            state.pageNum = parseInt(page)
        },
        setToken(state, token) {
            state.listToken = token
        },
        setNoDataIsShow(state, isOpen) {
            state.noDataIsShow = isOpen
        },
        setListIsShow(state, isOpen) {
            state.listIsShow = isOpen
        },
        setDetailIsShow(state, isOpen) {
            state.detailIsShow = isOpen
        },
        setListDetail(state, isOpen) {
            console.log(isOpen)
            state.listDetail = isOpen
        }
    },
    actions: {
        // payLoad: kw, page
        getSafeList(context, payLoad) {
            // 获取参数
            console.log(payLoad)
            // let organizationSearchParams = {
            //     param: { keyword: payLoad.kw, page: payLoad.page },
            //     token: payLoad.token
            // }
            // // 请求接口
            // return getInstitutionSorlList(organizationSearchParams.param, organizationSearchParams.token).then(res => {
            //     if (parseInt(res.code) === 103001) {
            //         window.location.href = res.data.jumpUrl
            //     } else if (parseInt(res.code) === 100000) {
            //         // 将列表信息和搜索值传入store (这个接口就算返回值是空格式也是正确的,载荷为res.data与searchKw)
            //         const payLoad = {
            //             kw: organizationSearchParams.param.keyword,
            //             pageNum: organizationSearchParams.param.page,
            //             data: res.data
            //         }
            //         if (res.data.data && res.data.data.length > 0) {
            //             context.commit('setListDataSate', true)
            //         } else {
            //             context.commit('setListDataSate', false)
            //         }
            //         context.commit('setList', payLoad)
            //     } else {
            //         context.commit('setListDataSate', false)
            //         console.warn('获取机构列表失败')
            //     }
            //     return res
            // })
            return getSafeList(payLoad).then(res => {
                if (res.data.list && res.data.list.length > 0) {
                    context.commit("setList", res.data.list);
                    context.commit("setListPageTotal", res.data.count);
                    context.commit("setListIsShow", true);
                    context.commit("setNoDataIsShow", false);
                    context.commit("setDetailIsShow", false);
                } else {
                    context.commit("setList", {});
                    context.commit("setListPageTotal", 1);
                    context.commit("setListIsShow", false);
                    context.commit("setDetailIsShow", false);
                    context.commit("setNoDataIsShow", true);
                }
            }).catch(err => {
                console.log(err)
            })
        },
        getToken(context) {
            return getToken().then(res => {
                if (res.success) {
                    context.commit('setToken', res.data)
                }
                return res
            })
        }
    },
    getters: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/safeServer.js